import { merge } from 'lodash';
import { useMemo } from 'react';
import { deleteUndefinedValues } from '@/utils/objects';
import { useTheme } from '@/components/widget/Layout/ThemeProvider';

const mapConfigToSectionStyles = config => deleteUndefinedValues({
  chartBackgroundColor: config.chartBackground
});

const mapThemeStylesToSectionStyles = theme => {
  var _theme$color, _theme$elements, _theme$elements$secti, _theme$elements$secti2, _theme$elements$secti3, _theme$elements$secti4;

  return deleteUndefinedValues({
    chartBackgroundColor: (_theme$color = theme.color) === null || _theme$color === void 0 ? void 0 : _theme$color.bodyBackground,
    listItemDividerStyle: (_theme$elements = theme.elements) === null || _theme$elements === void 0 ? void 0 : (_theme$elements$secti = _theme$elements.section) === null || _theme$elements$secti === void 0 ? void 0 : (_theme$elements$secti2 = _theme$elements$secti.Receipt) === null || _theme$elements$secti2 === void 0 ? void 0 : (_theme$elements$secti3 = _theme$elements$secti2.item) === null || _theme$elements$secti3 === void 0 ? void 0 : (_theme$elements$secti4 = _theme$elements$secti3.divider) === null || _theme$elements$secti4 === void 0 ? void 0 : _theme$elements$secti4.style
  });
};

export const useReceiptStyles = config => {
  const themeCtx = useTheme(); // The merge helper mutates the first object,
  // so we use an empty object to keep the default styles safe.
  // Merge styles in order: Default -> Defaults by Theme -> Theme Styles -> Config

  const themeStyles = useMemo(() => merge({}, mapThemeStylesToSectionStyles(themeCtx.theme || {}), mapConfigToSectionStyles(config)), [config, themeCtx.theme]);
  return {
    themeStyles,
    themeCtx
  };
};